import { render, staticRenderFns } from "./tagForm.vue?vue&type=template&id=559903e9"
import script from "./tagForm.vue?vue&type=script&lang=js"
export * from "./tagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports